import { ScopeType } from 'src/common/types';
import DataStore, { Query, QueryResult } from 'src/core/stores/data-store';

export interface ScopeSummary {
  id: string;
  code: number;
  title: string;
  scopeType: ScopeType;
  parentId?: string;
  hierarchy: string;
}

export class ScopeSummaryStore extends DataStore<ScopeSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/scopes`, []);
  }

  public async getData(query: Partial<Query>) {
    return await this.handleCallAsync(async () => {
      const response = await this.httpService.get<QueryResult<ScopeSummary>>(`${this.baseUrl}?${DataStore.buildUrl(query as Query)}`);
      return response.data.items;
    });
  }
}
